import {VAutocomplete, VSelect} from 'vuetify/lib';

const contentClass = 'app-select-menu--match-activator-width';

const createMatchActivatorWidth = (originalMenuProps) => ({
  data() {
    return {
      activatorWidth: null,
    };
  },
  computed: {
    $_menuProps() {
      const menuProps = originalMenuProps.call(this);
      const menuContentClass = [menuProps.contentClass, contentClass].filter(Boolean).join(' ');

      return {
        ...menuProps,
        contentClass: menuContentClass,
        ...(this.activatorWidth
          ? {
              minWidth: this.activatorWidth,
              maxWidth: this.activatorWidth,
            }
          : {}),
      };
    },
  },
  mounted() {
    this.updateActivatorWidth();

    if (window.ResizeObserver) {
      this.selectResizeObserver = new window.ResizeObserver(this.updateActivatorWidth);
      this.selectResizeObserver.observe(this.$el);
    } else {
      window.addEventListener('resize', this.updateActivatorWidth);
    }
  },
  updated() {
    if (this.isMenuActive) this.$nextTick(this.updateMenuItemTitles);
  },
  beforeDestroy() {
    if (this.selectResizeObserver) {
      this.selectResizeObserver.disconnect();
    } else {
      window.removeEventListener('resize', this.updateActivatorWidth);
    }
  },
  methods: {
    updateActivatorWidth() {
      const width = this.$el ? this.$el.offsetWidth : 0;
      this.activatorWidth = width || null;
    },
    updateMenuItemTitles() {
      const menuContent = this.$refs.menu && this.$refs.menu.$refs.content;
      if (!menuContent) return;

      menuContent.querySelectorAll('[role="option"]').forEach((option) => {
        const titleElement = option.querySelector('.v-list-item__title') || option;
        const title = titleElement.textContent.trim();

        if (title) option.setAttribute('title', title);
        else option.removeAttribute('title');
      });
    },
  },
});

export const VSelectWithMatchedMenu = VSelect.extend(
  createMatchActivatorWidth(VSelect.options.computed.$_menuProps)
);
export const VAutocompleteWithMatchedMenu = VAutocomplete.extend(
  createMatchActivatorWidth(VAutocomplete.options.computed.$_menuProps)
);
